<template>
  <div>
    <v-btn block color="primary" @click="showExportCustomer = true"> Export ลูกค้า </v-btn>

    <v-btn block color="primary" class="mt-4" @click="showExportStore = true">
      Export ร้านค้า
    </v-btn>

    <div class="text-xs-right mt-4">
      <v-btn color="grey" dark @click="clearPrivilege"> Clear สิทธิ์ </v-btn>
      <div class="red--text">
        *หากทำการ Clear ข้อมูลจำนวนสิทธิ์ของลูกค้า และจำนวนใบเสร็จของร้านค้าจะถูกเริ่มใหม่
      </div>
    </div>

    <ExportGroup
      v-model="showExportCustomer"
      @onExport="exportCustomer"
      :total="totalByCustomer"
    ></ExportGroup>

    <ExportGroup
      v-model="showExportStore"
      @onExport="exportStore"
      :total="totalByStore"
    ></ExportGroup>
  </div>
</template>

<script>
import pdfMake from 'pdfmake/build/pdfmake.js'
import pdfFonts from '@/assets/fonts/vfs_fonts.js'
import api from '@/api'
import { mapGetters } from 'vuex'
import ExportGroup from '@/components/elements/ExportGroup.vue'

pdfMake.vfs = pdfFonts.pdfMake.vfs
pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew.ttf',
    bold: 'THSarabunNew Bold.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf'
  }
}
export default {
  data() {
    return {
      loading: true,
      totalByCustomer: 0,
      totalByStore: 0,
      showExportCustomer: false,
      showExportStore: false
    }
  },
  components: {
    ExportGroup
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    selectedCampaign() {
      return this.$store.state.selectToaCampaign
    }
  },
  async mounted() {
    let customer_response = await this.getCustomer(25, 0, 'customer')
    let store_response = await this.getCustomer(25, 0, 'store')

    this.totalByCustomer = customer_response.total
    this.totalByStore = store_response.total
  },
  methods: {
    async getCustomer(limit, offset, type) {
      let data = {
        pageid: this.selectedBot.pageid,
        limit: limit,
        offset: offset,
        campaignid: this.selectedCampaign ? this.selectedCampaign.id : null,
        type: type,
        has_privilege: true
      }

      let response = await api.getToaCustomer(data)

      return {
        total: response ? response.total : 0,
        data: response ? response.data : []
      }
    },
    async exportCustomer(callback) {
      if (callback) {
        this.loading = true
        let { limit, offset } = callback
        let { data } = await this.getCustomer(limit, offset, 'customer')
        this.printPDF(data)
        this.loading = false
      }
    },
    async exportStore(callback) {
      if (callback) {
        this.loading = true
        let { limit, offset } = callback
        let { data } = await this.getCustomer(limit, offset, 'store')
        this.printPDF(data)
        this.loading = false
      }
    },
    async clearPrivilege() {
      if (!this.selectedCampaign) return false
      var result = await this.$swal.fire({
        title: this.$t('ต้องการ clear สิทธิ์ทั้งหมดหรือไม่'),
        type: 'warning',
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true,
        showCancelButton: true
      })
      if (result.value) {
        await api.clearPrivilege({
          body: {
            pageid: this.selectedBot.pageid,
            campaignid: this.selectedCampaign ? this.selectedCampaign.id : null
          }
        })

        await this.$swal.fire({
          type: 'success',
          title: this.$t('Success')
        })
      }
    },
    formatTemplate(items) {
      let template = []

      let table = items.map((el, index) => {
        return [
          { text: index + 1, style: { fontSize: 12 }, bold: true },
          { text: el.name, style: { fontSize: 12 }, bold: true },
          { text: el.receipt_no, style: { fontSize: 12 }, alignment: 'center' }
        ]
      })

      let header = [
        { text: 'ลำดับ', style: { fontSize: 12 }, bold: true },
        { text: 'ชื่อลูกค้า', style: { fontSize: 12 }, bold: true },
        { text: 'เลขที่ใบเสร็จ', style: { fontSize: 12 }, alignment: 'center' }
      ]
      let partition_size = 38

      let splited_orders = [],
        count = Math.ceil(table.length / partition_size)

      for (let i = 0; i < count; i++) {
        if (count == i) {
          splited_orders.push(table)
        } else {
          let t = table.splice(0, partition_size)
          splited_orders.push(t)
        }
      }

      template = splited_orders.map((el) => {
        return {
          table: {
            widths: [30, '*', '*'],
            body: [_.cloneDeep(header), ...el]
          }
        }
      })

      return template
    },
    async printPDF(items) {
      var data = await this.formatTemplate(items)
      var dd = {
        content: [data],
        pageSize: 'A4',
        pageMargins: [15, 15, 15, 15],
        styles: {
          header: {
            fontSize: this.headersize,
            // color: '#ff5656',
            bold: true
          },
          paragraph: {
            fontWeight: 200,
            fontSize: this.regularsize
          },
          container: {
            margin: [2, 2, 2, 2]
          },
          receipt: {
            fontSize: this.headersize,
            // color: '#ff5656',
            bold: true
          }
        },
        defaultStyle: {
          font: 'THSarabunNew'
        }
      }
      this.loading = false
      pdfMake.createPdf(dd).open()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/ExportCustomerAndStore.vue